import { useEffect, useState, useRef, useContext } from "react";
import axios from "axios";
import * as Stomp from "stompjs";
import * as SockJS from "sockjs-client";
import { OptionDataContenxt } from "./OptionChartDashboard";
import { useTradingColors } from "../Spot/tradingColorConfig";
import "../Spot/Spot.css";

const OptionRightTable = () => {
  const { currencycode, basecurrency, assetpair } =
    useContext(OptionDataContenxt);
  const { upColor, downColor } = useTradingColors();
  const themeColor = "Dark";
  const theme = localStorage.getItem("theme");
  const [marketTradeRecords, setMarketTradeRecords] = useState([]);
  const [ctpdata, setCtpdata] = useState(null);
  const [ltpdata, setLtpData] = useState(null);
  const tradep = parseInt(localStorage.getItem("priceprc")) || 2;
  const tradem = parseInt(localStorage.getItem("amountprc")) || 2;
  // const [currency_code, setCurrencyCode] = useState(localStorage.getItem('buying_crypto_asset') || 'BTC');
  // const [base_currency, setBaseCurrency] = useState(localStorage.getItem('selling_crypto_asset') || 'USD');
  let buyingAsset = localStorage.getItem("buying_crypto_asset") || "BTC";
  let sellingAsset = localStorage.getItem("selling_crypto_asset") || "INR";
  const token = localStorage.getItem("access_token");
  const websocketRef = useRef(null);
  const webSocketEndPoint =
    "https://options-socket.paybito.com/oSocketStream/ws";
  const topic = "/user/topic/stream";
  const topicForBtcUsd = "/topic/stream/BTCUSD";

  let stompClient = null;
  let reqNo = null;
  const connectWebSocket = () => {
    const accessToken = localStorage.getItem("access_token");
    if (accessToken) {
      const ws = new SockJS(webSocketEndPoint);
      stompClient = Stomp.over(ws);

      stompClient.connect(
        {},
        (frame) => {
          let topicToSubscribe = "";
          subscribe();
          websocketRef.current.socket = stompClient;
          const buyingAsset =
            localStorage.getItem("buying_crypto_asset") || "BTC";
          const sellingAsset =
            localStorage.getItem("selling_crypto_asset") || "INR";

          if (buyingAsset && sellingAsset) {
            if (
              buyingAsset.toLowerCase() === "btc" &&
              sellingAsset.toLowerCase() === "usd"
            ) {
              topicToSubscribe = topicForBtcUsd;
            } else {
              topicToSubscribe = topic;
            }

            stompClient.subscribe(topic, (sdkEvent) => {
              const message = JSON.parse(sdkEvent.body);

              // Call the subscribeMessage function if defined
              if (websocketRef.current.subscribeMessage) {
                websocketRef.current.subscribeMessage(message);
              }
              onMessageReceived(sdkEvent);
            });
          }
        },
        errorCallback
      );
    }
  };

  const errorCallback = (error) => {
    if (localStorage.getItem("access_token")) {
      setTimeout(() => {
        connectWebSocket();
      }, 5000);
    }
  };

  const sendMessage = (message) => {
    if (stompClient) {
      let sendEndpoint = "";
      if (buyingAsset && sellingAsset) {
        if (buyingAsset === "btc" && sellingAsset === "usd") {
          sendEndpoint = "/app/sendRequest/BTCUSD";
        } else {
          sendEndpoint = "/app/sendRequest";
        }
        stompClient.send(sendEndpoint, {}, JSON.stringify(message));
      }
    }
  };

  const onMessageReceived = (message) => {
    const parsedMessage = JSON.parse(message.body);
    changeMessage(parsedMessage);
    const tradeHistorydata = parsedMessage;
    if (tradeHistorydata.e === "trade") {
      console.log("tradeHistorydata option->>>", tradeHistorydata);
      setMarketTradeRecords((prevRecords) => {
        let newRecords = [...prevRecords];

        tradeHistorydata.tH.forEach((trade) => {
          const price = parseFloat(trade.price).toFixed(parseInt(tradep));
          const quantity = parseFloat(trade.quantity).toFixed(parseInt(tradem));
          const newTrade = {
            quantity,
            price,
            timestamp: trade.timestamp,
            side: trade.side,
            newask: trade.side === "ASK",
            newbid: trade.side === "BID",
          };

          newRecords.unshift(newTrade);
        });

        // Ensure the 'newask' and 'newbid' properties are properly reset
        newRecords = newRecords.map((record, index) => ({
          ...record,
          newask: index === 0 && record.newask,
          newbid: index === 0 && record.newbid,
        }));

        // Limit array length to 100
        if (newRecords.length > 100) {
          newRecords = newRecords.slice(0, 100);
        }

        return newRecords;
      });

      setLtpData((prevLtpData) => marketTradeRecords[0]?.price || prevLtpData);
    }
  };

  const changeMessage = (obj) => {
    console.log("Received Message:", obj);
  };

  const subscribe = () => {
    if (buyingAsset && sellingAsset) {
      reqNo = Math.floor(Math.random() * 1000) + 1;
      const req = {
        method: "SUBSCRIBE",
        params: [
          `${assetpair}@ticker`,
          `${assetpair}@depth`,
          `${assetpair}@trade`,
        ],
        id: reqNo,
      };
      setTimeout(() => {
        sendMessage(req);
      }, 10000);

      localStorage.setItem("isUnsubscribeOccured", "false");
    }
  };

  const unsubscribe = () => {
    const buyingAsset = buyingAsset;
    const sellingAsset = sellingAsset;

    if (buyingAsset && sellingAsset) {
      const req = {
        method: "UNSUBSCRIBE",
        params: [
          `${buyingAsset}/${sellingAsset}@ticker`,
          `${buyingAsset}${sellingAsset}@depth`,
          `${buyingAsset}${sellingAsset}@trade`,
        ],
        id: reqNo,
      };

      sendMessage(req);

      localStorage.setItem("isUnsubscribeOccured", "true");
    }
  };

  const disconnectWebSocket = () => {
    if (stompClient && stompClient.connected) {
      console.log("Disconnecting WebSocket...");
      stompClient.disconnect(() => {
        console.log("WebSocket Disconnected");
        websocketRef.current.socket = null; // Reset WebSocket reference
      });
    } else {
      console.warn("WebSocket is not connected, skipping disconnect.");
    }
  };

  const getTradePrice = (m) => {
    return parseFloat(m.price).toFixed(tradep);
  };

  const getTradeAmount = (m) => {
    return parseFloat(m.quantity).toFixed(tradem);
  };

  useEffect(() => {
    fetchTradeHistory();

    return () => {
      if (websocketRef.current) {
        disconnectWebSocket(); // Disconnect WebSocket when the component unmounts
      }
    };
  }, [assetpair]);

  const fetchTradeHistory = async () => {
    try {
      const response = await axios.get(
        `https://options-socket.paybito.com/oSocketStream/api/tradeHistory?symbol=${assetpair}&limit=50`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${token}`,
          },
        }
      );
      const result = response.data;

      setMarketTradeRecords(result);

      websocketRef.current = {
        socket: null,
        subscribeMessage: null,
      };

      connectWebSocket();

      //   tradeBookData(result);
      // setCtpdata(result[0].price);
    } catch (error) {
      console.error("Error fetching trade history:", error);
    }
  };
  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString("en-US", { hour12: false });
  };
  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      {/* Header with Title */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "6px 12px",
          borderBottom: "1px solid rgba(125, 125, 125, 0.15)",
          flexShrink: 0,
        }}
      >
        <span
          style={{
            fontWeight: 700,
            fontSize: "11px",
            letterSpacing: "0.01em",
            color: theme === "light" ? "#1e2329" : "#eaecef",
          }}
        >
          Market Trades
        </span>
      </div>

      {/* Table Body */}
      <div
        className="table_content right_table"
        style={{
          flex: 1,
          minHeight: 0,
          overflowY: "auto",
          overflowX: "hidden",
          margin: 0,
          paddingBottom: 0,
        }}
      >
        <table style={{ width: "100%", tableLayout: "fixed" }}>
          <colgroup>
            <col style={{ width: "32%" }} />
            <col style={{ width: "34%" }} />
            <col style={{ width: "34%" }} />
          </colgroup>
          <thead
            style={{
              position: "sticky",
              top: 0,
              zIndex: 1,
              backgroundColor: "var(--body-color-less)",
            }}
          >
            <tr>
              <th
                style={{
                  color: theme === "light" ? "black" : "",
                  textAlign: "start",
                  paddingLeft: "12px",
                }}
              >
                Time
              </th>
              <th
                style={{
                  color: theme === "light" ? "black" : "",
                  textAlign: "center",
                }}
              >
                Amount
              </th>
              <th
                style={{
                  color: theme === "light" ? "black" : "",
                  textAlign: "end",
                  paddingRight: "12px",
                }}
              >
                Price
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              style={{
                height: "8px",
                borderBottom: "1px solid rgb(62, 62, 62)",
              }}
            />
            {marketTradeRecords?.length !== 0 ? (
              marketTradeRecords?.map((m, i) => (
                <tr key={i}>
                  <td
                    className={`askBidTd text-start ${
                      theme === "dark" ? "" : "ticker-light"
                    } ${m.newbid ? "bg-green-300" : ""}`}
                    style={{
                      textAlign: "left",
                      paddingLeft: "12px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {formatTime(m.timestamp)}
                  </td>
                  <td
                    className={`askBidTd text-center ${
                      theme === "dark" ? "" : "ticker-light"
                    } ${m.newask ? "bg-red-300" : ""}`}
                    style={{
                      textAlign: "center",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {getTradeAmount(m)}
                  </td>
                  <td
                    className={`askBidTd text-end ${
                      m.newbid ? "bg-green-300" : ""
                    }`}
                    style={{
                      color: m.side === "BID" ? upColor : downColor,
                      textAlign: "right",
                      paddingRight: "12px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {getTradePrice(m)}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={3}
                  className="text-center"
                  style={{ padding: "16px", color: "#848e9c" }}
                >
                  No Data
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OptionRightTable;
